import { defineStore } from 'pinia'
import { UserRole } from '~/types/userRole'
import { isUserRole } from '~/composables/utils'
import { useAuthStore } from '~/stores/authStore'
import { useAuthFetch } from '~/composables/useAuthFetch'
import { AppEvents } from '~/types/events'
import {computed, nextTick} from 'vue'
import { useChatStore } from '~/stores/chatStore'
import {ResponseStatus} from "../types/responseStatus";

interface UserState {
  userInfo: any
  offers: any
  isLoading: boolean
  messages: any[]
}

export const useUserStore = defineStore('user', () => {
  const { $toast, $listen, $event, $i18n, $socketUtils } = useNuxtApp()
  const $t = $i18n.t;

  const userInfo: any = ref({})
  const messages = ref([])
  const offers = ref([])
  const isLoading = ref(false)

  const companyBadge = ref({});
  const companyBadges = ref([]);
  const userInfoReady = ref(false)
  const hasPremium =  computed(() => {
    return ([UserRole.MANAGER, UserRole.SALES_REP].includes(userInfo.value.role) && userInfo.value.companyData?.hasPremium) || false;
  })

  function fetchContacts({ onResponseCallback = null }) {
    useAuthFetch(`/users/${userInfo.value.userId}/contacts`, {
      method: 'GET',
      onResponse({ response }) {
        if (onResponseCallback) {
          onResponseCallback({ response })
        }
      },
    }, true)
  }
  function fetchUserProfileData({ onResponseCallback = null }) {
    const { authenticated } = storeToRefs(useAuthStore())
    if (!authenticated.value) {
      return
    }
    userInfoReady.value = false
    let infoUrl
    const config = useRuntimeConfig()
    switch (userInfo.value.role) {
      case UserRole.SALES_REP:
        // eslint-disable-next-line no-case-declarations
        infoUrl = `/companies/salesreps/${userInfo.value.userId}`
        // eslint-disable-next-line no-case-declarations
        useAuthFetch(infoUrl, {
          method: 'GET',
          headers: {
            'stripe-api-key': config.public.STRIPE_API_KEY
          },
          onResponse({ response }) {
            console.log(response._data)

            if (onResponseCallback) {
              onResponseCallback({ response })
            }
            userInfo.value = { ...userInfo.value, ...response._data }

            userInfoReady.value = true
          },
        }, true)

        break
      case UserRole.MANAGER:
        // eslint-disable-next-line no-case-declarations
        infoUrl = `/managers/${userInfo.value.userId}`
        // eslint-disable-next-line no-case-declarations
        useAuthFetch(infoUrl, {
          method: 'GET',
          headers: {
            'stripe-api-key': config.public.STRIPE_API_KEY
          },
          async onResponse({ response }) {


            console.log(response._data)

            if (onResponseCallback) {
              onResponseCallback({ response })
            }
            userInfo.value = { ...userInfo.value, ...response._data }
            await fetchCompanyTitles();
            companyBadge.value = companyBadges.value.find(b => b._id === userInfo.value.companyData?.companyTitleId );

            userInfoReady.value = true
          },
        }, true)

        break
      case UserRole.CLIENT:
        // eslint-disable-next-line no-case-declarations
        infoUrl = `/users/${userInfo.value.userId}`
        // eslint-disable-next-line no-case-declarations
        useAuthFetch(infoUrl, {
          method: 'GET',
          onResponse({ response }) {
            console.log(response._data)

            if (onResponseCallback) {
              onResponseCallback({ response })
            }
            userInfo.value = { ...userInfo.value, ...response._data }

            userInfoReady.value = true
          },
        }, true)

        fetchContacts({
          onResponseCallback: ({ response }) => {
            userInfo.value.contacts = response._data
          },
        })

        break
    }
  }
  async function fetchCompanyTitles() {
    const { data, status } = await useAuthFetch(`/managers/company-titles`, {});

    if (status.value === ResponseStatus.SUCCESS) {
      companyBadges.value = data.value;
    }

  }


  function setUserRole(role: string) {
    userInfo.value.role = role
  }

  function setPremiumStatus({hasPremium = false, email = null}) {
    return new Promise((resolve) => {
    if (!email) {
      throw Error('No companyIdl give');
    }
    if (!isUserRole.value([ UserRole.SALES_REP, UserRole.MANAGER])) {
      resolve({ status: -1 })
    }

    const config = useRuntimeConfig()

      useAuthFetch(`/companies/premium`, {
        headers: {
          'stripe-api-key': config.public.STRIPE_API_KEY
        },
        method: 'PUT', body: {
          hasPremium,
          email
        }, onResponse({response}) {
          if (response._data.statusCode === 400) {
            resolve({ status:  ResponseStatus.ERROR  })
          }
          resolve({ status: ResponseStatus.SUCCESS })
        }
      }, true)
    })
  }

  const getCompanyId = computed(() => {
    return userInfo.value.cognitoOwnerId;
  })
  async function fetchOffers(category: string = '') {
    console.log(category)
    isLoading.value = true
    /*
      Jak bedzie backend zrobiony

      const config = useRuntimeConfig()

      let endpoint = `${config.public.API_BASE_URL}/offers`
      if (category) {
        endpoint += `/${category.toLowerCase()}`
      }

      const { data } = await useFetch(endpoint)*/
    setTimeout(() => {
      offers.value = [
        {
          _id: '65ab08a325550678777f7aca',
          title: 'test',
          description: '2321',
          price: 234324,
          photos: [
            {
              _id: '65ab08a325550678777f7acb',
              url: 'https://kamil-local.s3.eu-west-1.amazonaws.com/offers/KWTDr9REam_0',
            },
          ],
        },
        {
          _id: '65ab0f2525550678777f7b81',
          profileId: 'test123',
          title: 'ijij',
          description: 'ojiijojiooijij',
          price: 878778,
          photos: [
            {
              _id: '65ab0f2525550678777f7b82',
              url: 'https://kamil-local.s3.eu-west-1.amazonaws.com/offers/0GwHGOpwvQ_0',
            },
          ],
        },
      ]
      isLoading.value = false
    }, 2000)
  }

  function removeFromFavourites({ offerId, cognitoUserId }) {
    useAuthFetch(`/users/${cognitoUserId}/favourites/${offerId}`, {
      method: 'DELETE',
      onResponse() {
        $event(AppEvents.FETCH_USER_DATA)
      },
    })
  }

  function addToFavourites({ offerId, cognitoUserId, salesRepCognitoId }) {
    useAuthFetch(
      `/users/${cognitoUserId}/favourites/${salesRepCognitoId}/${offerId}`,
      {
        method: 'POST',
        onResponse() {
          $event(AppEvents.FETCH_USER_DATA)
        },
      }
    )
  }

  const isOfferAddedToFavourite = computed(() => ({ offerId }) => {
    return userInfo.value.favouriteOffers.some(o => o._id === offerId)
  })

  function setProfilePhoto(file: File, endpoint = null) {
    const formData = new FormData()
    formData.append('file', file)

    let routeType = '/managers'
    if (isUserRole.value(UserRole.SALES_REP)) {
      routeType = '/companies/salesreps'
    }
    if (isUserRole.value(UserRole.CLIENT)) {
      routeType = '/users'
    }

    if (endpoint) {
      routeType = '/companies/salesreps'
    }

    useAuthFetch(
      `${routeType}/${userInfo.value.cognitoOwnerId ?? userInfo.value.cognitoUserId}/photo/`,
      {
        method: 'POST',
        body: formData,
        onResponse({ response }) {
          if (isUserRole.value(UserRole.SALES_REP)) {
            userInfo.value.salesRepData.image = response._data.fileUrl
            $event('change-avatar-photo')
            return
          }
          userInfo.value.companyData.image = response._data.fileUrl
          $event('change-avatar-photo')
        },
      }
    )
  }
  function updateProfileInfo(key, value) {
    if (key in userInfo.value) {
      userInfo.value[key] = value
    }
  }

  const getUserInitials = computed(() => {
    let userName = ''
    if (isUserRole.value(UserRole.MANAGER)) {
      userName = userInfo.value.companyData?.name ?? ''
    }
    if (isUserRole.value(UserRole.SALES_REP)) {
      const firstName = userInfo.value?.salesRepData?.firstName ?? ''
      const lastName = userInfo.value?.salesRepData?.lastName ?? ''
      userName = `${firstName} ${lastName}`
    }
    if (isUserRole.value(UserRole.CLIENT)) {
      const firstName = userInfo.value?.firstName ?? ''
      const lastName = userInfo.value?.lastName ?? ''
      userName = `${firstName} ${lastName}`
    }

    return userName
      ? userName
          ?.split(' ')
          .map(name => name.charAt(0).toUpperCase())
          .join('')
      : ''
  })
  const getUserContactById = computed(() => {
    return (profileId: number | null) => {
      if (!profileId) return null
      return userInfo.value.contacts.find((c: any) => c.profileId === profileId)
    }
  })

  const getOffers = computed(state => {
    return offers.value
  })

  const getSearchedOffers = computed(state => {
    return (searchedCity: string = '') =>
      offers.value.filter(
        (o: any) => o.city.toLowerCase() === searchedCity.toLowerCase()
      )
  })

  const getUserEmail = computed(state => {
    switch (userInfo.value.role) {
      case UserRole.SALES_REP:
        return userInfo.value.salesRepData?.email || userInfo.value.companyData?.email;
      case UserRole.MANAGER:
        return userInfo.value.managerData?.email;
      case UserRole.CLIENT:
        return userInfo.value.email;
      default:
        return '';
    }
  })

  const getSubscriptionUserEmail = computed(() => {
    switch (userInfo.value.role) {
      case UserRole.SALES_REP:
        return userInfo.value.companyData?.managerEmail;
      case UserRole.MANAGER:
        return userInfo.value.managerData?.email;
      default:
        return '';
    }
  })

  $listen(AppEvents.FETCH_OFFERS, () => {
    fetchUserProfileData({
      onResponseCallback: async ({ response }) => {
        console.log(response._data)

        await nextTick(() => {
          userInfo.value.offers = response._data.offers
        })
      },
    })
  })

  $listen(AppEvents.FETCH_COURSES, () => {
    fetchUserProfileData({
      onResponseCallback: async ({ response }) => {
        console.log(response._data)

        await nextTick(() => {
          userInfo.value.courses = response._data.courses
        })
      },
    })
  })

  $listen(AppEvents.FETCH_PROMO_OFFERS, () => {
    fetchUserProfileData({
      onResponseCallback: async ({ response }) => {
        console.log(response._data)

        await nextTick(() => {
          userInfo.value.promos = response._data.promos
        })
      },
    })
  })

  $listen(AppEvents.FETCH_STEPS, () => {
    $toast.info('Zaktualizowano kroki')
    fetchUserProfileData({
      onResponseCallback: async ({ response }) => {
        console.log(response._data)

        await nextTick(() => {
          userInfo.value.steps = response._data.steps
        })
      },
    })
  })

  $listen(AppEvents.FETCH_USER_DATA, () => {
    fetchUserProfileData({})
  })

  return {
    hasPremium,
    userInfoReady,
    userInfo,
    messages,
    offers,
    isLoading,
    setProfilePhoto,
    fetchUserProfileData,
    setUserRole,
    setPremiumStatus,
    updateProfileInfo,
    addToFavourites,
    removeFromFavourites,
    fetchContacts,
    isOfferAddedToFavourite,
    getUserInitials,
    getUserContactById,
    getOffers,
    getSearchedOffers,
    getUserEmail,
    getSubscriptionUserEmail,
    getCompanyId,
    companyBadge,
    companyBadges
  }
})
